import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock, FaFacebook, FaLinkedinIn, FaInstagram, FaTiktok } from 'react-icons/fa';
import Send from '../assets/img/char.jpeg';
import Navbar from './NavBar';
import Contact from './Contact';
const Contact2 = () => {
  return (
    <>
    <Navbar />
    <div name='contact2' className='w-full h-screen bg-white justify-center items-center pt-4 pb-32 text-[#15381b]'>
          {/* <div className='py-4 pt-32 grid justify-center items-center px-4 lg:px-0 md:px-0'>
              <p className='text-4xl font-bold inline'>Contact Us</p>
              <p className='text-[#8892b0] py-4'>Submit the form below or send an email - <a href="mailto:info@adf.ng" className="text-[#15381b]">info@adf.ng</a></p>
          </div>
          <div className='flex justify-center items-center gap-1 px-4 pl-8 lg:pl-20 md:pl-0'>
              <div className='flex flex-col lg:max-w-[700px] lg:w-[600px] w-[400px] bg-[#15381b] justify-center items-center pt-10'>
                  <form method='POST' action="https://usebasin.com/f/0b9b7194d0f2" className='flex flex-col lg:max-w-[600px] lg:w-[500px] w-[350px] mx-auto'>
                      <input className='bg-[#f9fffa] text-gray-800 p-2 lg:mx-0 md:mx-0 mx-2 rounded-lg' type="text" placeholder='Name' name='name' />
                      <input className='my-4 p-2 text-gray-800 bg-[#f9fffa] lg:mx-0 md:mx-0 mx-2 rounded-lg' type="email" placeholder='Email' name='email' />
                      <textarea className='bg-[#f9fffa] text-gray-800 p-2 lg:mx-0 md:mx-0 mx-2 rounded-lg' name="message" rows="10" placeholder='Message'></textarea>
                      <button className='text-gray-400 border-2 hover:bg-[#f9fffa] hover:border-[#b1ffbe] hover:text-[#15381b] px-4 py-3 my-8 mx-auto flex items-center'>Send a Message</button>
                  </form>
              </div>
              <div className='mr-4' style={{ width: '30%' }}>
                  <img src={Send} alt="Send" className='w-[80%] h-[80%] hidden md:block lg:block' />
              </div>
          </div> */}
          <div className='bg-[#15381b] text-white mt-10'>
        <div className='lg:flex md:flex grid flex-grid lg:gap-28 md:gap-20 gap-4 items-center justify-center pt-10 lg:px-0 md:px-0 px-4'>
          <div className='flex items-center pt-5 lg:pt-0 md:pt-0'>
            <FaMapMarkerAlt className='text-2xl' />
            <a href="https://www.google.com/maps?q=35+Adeola+Hopewell+Street,+Victoria+Island,+Lagos" className='ml-2' target="_blank" rel="noopener noreferrer">35, Adeola Hopewell Street, Victoria Island, Lagos</a>
          </div>
          <div className='flex items-center mt-5 lg:mt-3'>
            <FaPhone className='text-2xl' />
            <a href="tel:+2347031447139" className='ml-2'>+2347031447139</a>
          </div>
          <div className='flex items-center mt-5 lg:mt-3'>
            <FaClock className='text-2xl' />
            <p className='ml-2'>Monday to Friday - 9:00 am to 4:00 pm</p>
          </div>
        </div>
        <div className="flex items-center justify-center mt-10 pb-12 gap-10">
          <a href="https://www.facebook.com/profile.php?id=61556523255238&mibextid=LQQJ4d"><FaFacebook className="text-2xl cursor-pointer" /></a>
          <a href="http://linkedin.com/in/kuramo-development-trust-kdt-9600b72a6"><FaLinkedinIn className="text-2xl cursor-pointer" /></a>
          <a href="https://www.instagram.com/kuramo_d_trust?utm_source=qr"><FaInstagram className="text-2xl cursor-pointer" /></a>
          <a href="https://twitter.com/Kuramo_D_Trust"><FontAwesomeIcon icon={faXTwitter} className="text-2xl cursor-pointer" /></a>
          <a href="https://www.tiktok.com/@kuramo_d_trust?_t=8kEsfN1JC45&_r=1"><FaTiktok className="text-2xl cursor-pointer" /></a>
        </div>

      </div>
      </div>
      </>
  );
};

export default Contact2;
